<template>
  <div class="create-update-db-item">
    <div class="modal-backdrop"></div>
    <div class="modal">
      <template v-if="!loading">
        <div class="pull-right">
          <div v-if="!isAddingNewItem">
            <span
              class="btn-logs"
              @click="openCustomDBLogs(selectedItem[getSqlKey('id')])"
            ></span>
          </div>
          <div v-if="!isAddingNewItem">
            <span class="btn-download" @click="exportItem()"></span>
          </div>
          <generalDropdown v-if="!isAddingNewItem" :isCaretVisible="false">
            <template v-slot:iconContainer>
              <span class="btn-more"></span>
            </template>
            <template v-slot:optionData>
              <b-dropdown-item
                v-for="action in actionList"
                :key="action.id"
                @click="runAction(action.id)"
              >
                {{ action.name }}
              </b-dropdown-item>
              <b-dropdown-item @click="createNewAction()">
                <i class="far fa-plus-square me-2"></i>Neue Aktion hinzufügen
              </b-dropdown-item>
            </template>
          </generalDropdown>
          <span class="btn-close" @click="close(false)"></span>
        </div>
        <h1 v-if="!isAddingNewItem">Datensatz bearbeiten</h1>
        <h1 v-if="isAddingNewItem">Datensatz erstellen</h1>
        <div v-if="isScrollVisible" class="serach-main-wrap custom-item-edit">
          <div class="search-wrap">
            <div class="search" v-bind:class="{ active: searchActive }">
              <span class="search-icon" @click="toggleSearch"></span>
              <input ref="search" name="search" v-model="search" />
            </div>
          </div>
        </div>
      </template>
      <!-- Form-Builder for update-item -->
      <FormBuilder
        v-if="showFormbuilderOnItemEditMode"
        ref="formBuilder"
        :isAddOnly="database.add_only"
        :elements="schemaWithSelectedElValues"
        :structure="getDatabaseLayout()"
        :isEditable="false"
        :databaseMeta="database"
        :isContentEditable="database.access_level != 'read'"
        :isAddingNewItem="!isAddingNewItem"
        :search="search"
        @saveItem="updateItem"
        :hasFooter="database.access_level != 'read' && !loading"
      />
      <!-- Form-Builder for Add-New-Item -->
      <FormBuilder
        v-if="isAddingNewItem && !loading"
        ref="formBuilder"
        :elements="emptySchema"
        :structure="getDatabaseLayout()"
        :isEditable="false"
        :databaseMeta="database"
        :isContentEditable="database.access_level != 'read'"
        :isAddingNewItem="isAddingNewItem"
        :search="search"
        @saveItem="updateItem"
        :hasFooter="database.access_level != 'read' && !loading"
      />
      <div class="footer" v-if="database.access_level != 'read' && !loading">
        <button
          class="btn-black"
          :class="{ disabled: !isAddingNewItem && database.add_only }"
          :disabled="
            (!isAddingNewItem && database.add_only) || search.length > 0
          "
          @click="submitChildForm"
        >
          Speichern
        </button>
      </div>
      <div class="loading" v-if="loading">
        <div class="progress-icon-wrapper">
          <p>
            {{
              isAddingNewItem
                ? 'Eintrag wird erstellt...'
                : 'Eintrag wird angepasst...'
            }}
          </p>
          <div class="progress-icon"></div>
        </div>
      </div>
    </div>
    <div class="custom-db-log-modal">
      <updates
        v-if="isShowupdate"
        :updates="logs"
        dbType="custom"
        @close="closeCustomDBLogs"
      />
    </div>
    <htmlViewer
      v-if="htmlViewerModal.isHtmlViewerVisible"
      @close="closeHtmlViewer"
      :myHtml="htmlViewerModal.myHtml"
    >
    </htmlViewer>
  </div>
</template>

<script>
import FormBuilder from './widgets/FormBuilderV2.vue';
import { getPreSignedUrl, uploadFile } from '../utils/helpers.js';
import Updates from './Updates.vue';
import { Auth } from 'aws-amplify';
import Store from '../store/store';
import GeneralDropdown from './core/general-dropdown.vue';
import { runFlowById } from '../services/workflow.service';
import htmlViewer from './modals/htmlViewer.vue';
import { getDataBaseLogs } from '../services/userTable';

export default {
  name: 'customDetails',
  data() {
    return {
      loading: false,
      name: null,
      item: null,
      searchActive: false,
      search: '',
      isShowupdate: false,
      logs: [],
      htmlViewerModal: {
        isHtmlViewerVisible: false,
        myHtml: null,
      },
      isScrollVisible: false,
    };
  },
  props: {
    database: Object,
    selectedItem: Object,
    isAddingNewItem: { type: Boolean },
    dataSchema: Array,
  },
  methods: {
    setLoader(bool) {
      this.loading = bool;
    },
    getDatabaseLayout(){
      const layout = this.database.hasOwnProperty('layout') ? this.database.layout : null
    
      if (layout == null || layout == "") return {tabs:[{id:0,rows:[{id:0,cols:[{id:0}]}]}]}
      else return JSON.parse(layout)
    },
    close(updateItems) {
      this.$emit('close', this.selectedId, updateItems);
    },
    submitChildForm: function () {
      if (this.search.length > 0) return;
      this.$refs.formBuilder.formSubmit();
    },
    async updateItem(e) {
      this.setLoader(true);
      const url = `${process.env.VUE_APP_DATA_API}/user-tables/${this.tableName}/items`;

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('content-type', 'application/json');

      const formElements = await this.formElementsAsObject(e);
      // Remove frontend keys
      let i = JSON.parse(JSON.stringify(formElements));
      delete i.selected;
      delete i.loading;

      const payload = {
        item: i,
      };

      let requestMethod = 'POST';
      if (!this.isAddingNewItem) requestMethod = 'PUT';
      try {
        const response = await fetch(url, {
          headers: myHeaders,
          body: JSON.stringify(payload),
          method: requestMethod,
        });
        if (response.status == 200) {
          this.setLoader(false);
          this.close(true);
          this.saveLogs(e, i.id);
        } else if (response.status == 401)
          throw new Error('Access Token has expired');
        else new Error(response.statusText);
      } catch (err) {
        this.setLoader(false);
        if (err == 'Error: Access Token has expired') {
          localStorage.clear(),
            this.$router.push({
              name: 'auth',
              params: { message: 'Sitzung abgelaufen' },
            });
        } else {
          new Error(err);
        }
      }
    },
    getImgUrl: function (img) {
      if (img) {
        var images = require.context('../assets/img/', false, /\.png$/);
        return images(img);
      } else return '';
    },
    newID: function () {
      let id = Math.round(
        Math.random() * 100000 + new Date().getTime() - Math.random()
      );
      return id;
    },
    async formElementsAsObject(el) {
      let item = {};

      const vm = this;
      for (const [i, formBuilderItem] of el.entries()) {
        if (
          formBuilderItem &&
          formBuilderItem.type === 'filenew' &&
          el[i].value &&
          (this.isAddingNewItem ||
            (!this.isAddingNewItem &&
              el[i].value &&
              this.formElements[i].value &&
              el[i].value.name !== this.formElements[i].value.name))
        ) {
          try {
            const preSignedUrl = await getPreSignedUrl(
              vm.database.name,
              formBuilderItem.value.name
            );
            formBuilderItem.value.link = preSignedUrl.signature.key;
            await uploadFile(preSignedUrl, formBuilderItem.files);
          } catch (err) {
            // eslint-disable-next-line no-console
            console.log('error', err);
          }
        }
      }

      // Used to keep items that are not in schema for e.g created etc.
      if (!this.isAddingNewItem) {
        item = this.selectedItem;
        item.updated = new Date().getTime();
      }

      el.forEach((e) => {
        if (e.type === 'radio') {
          let el = e.options.find((i) => i.checked === true);
          el != undefined ? (item[e.name] = el.label) : (item[e.name] = null);
        } else item[e.name] = e.value;
      });

      return item;
    },
    saveLogs(elements, contextId) {
      const time = new Date().getTime();
      let dbItemLog = {
        author: this.user.attributes.sub,
        'time-start': time,
        'time-end': time,
        'context-parent-type': 'database',
        'context-type': 'database-item',
      };
      if (!this.isAddingNewItem) {
        const dbItemEdits = elements.reduce((acc, cur) => {
          if (cur.name != 'id' && this.item[cur.name] != cur.value) {
            acc.push({
              key: cur.label,
              'old-value': this.item[cur.name],
              'new-value': cur.value,
            });
          }
          return acc;
        }, []);
        dbItemLog = {
          ...dbItemLog,
          'context-parent-id': this.database.name,
          'context-id': `${this.database.name}::${contextId}`,
          'activity-values': {
            'activity-type': 'database-entry-update',
            edits: dbItemEdits,
          },
        };
        if (dbItemEdits.length) this.$emit('putLogs', dbItemLog);
      } else {
        dbItemLog = {
          ...dbItemLog,
          'context-parent-id': null,
          'context-id': this.database.name,
          'activity-values': {
            'activity-type': 'database-entry-create',
            edits: [{ 'item-id': contextId }],
          },
        };
        this.$emit('putLogs', dbItemLog);
      }
    },
    // set focus on input (search)
    toggleSearch() {
      this.searchActive = !this.searchActive;
      if (this.searchActive) {
        this.$refs.search.focus();
      } else {
        this.search = '';
      }
    },
    getSqlKey(key) {
      if (this.database.sql_cdls && JSON.parse(this.database.sql_cdls)[key]) {
        return JSON.parse(this.database.sql_cdls)[key];
      } else return key;
    },
    getContextId(id) {
      if (id) return `${this.database.name}::${id}`;
      else return this.database.name;
    },
    async getLogs(id) {
      try {
        const response = await getDataBaseLogs(id);
        if (response.status == 200) {
          const json = await response.data;

          this.logs = json;
        }
      } catch (e) {
        this.isLoading = false;
      }
    },
    async openCustomDBLogs(id) {
      setTimeout(() => {
        this.isShowupdate = true;
      }, 50);
      await this.getLogs(this.getContextId(id));
    },
    closeCustomDBLogs() {
      this.isShowupdate = false;
    },
    hideUpdateModal(event) {
      const containingElement = document.querySelector('.custom-db-log-modal');
      if (!containingElement.contains(event.target)) {
        // hide log modal, click was outside container.
        if (this.isShowupdate) this.isShowupdate = false;
      }
    },
    checkRefreshToken: function () {
      if ((Date.now() - this.lastTokenRefresh) / 60000 > 15)
        this.refreshSession();
    },
    refreshSession: async function () {
      try {
        const cognitoUser = await Auth.currentAuthenticatedUser();
        const currentSession = await Auth.currentSession();
        cognitoUser.refreshSession(
          currentSession.refreshToken,
          (err, session) => {
            // Replace user with new token
            let user = this.user;
            user.signInUserSession = session;

            // Set updated user
            Store.commit('setUser', user);

            // Set new refresh time
            this.lastTokenRefresh = Date.now();

            return session;
          }
        );
      } catch (e) {
        // Verification failed, log out
        Store.commit('setUser', null);

        return null;
      }
    },
    objectsToCSV: async function (arr) {
      // Remove frontend keys
      let copy_arr = JSON.parse(JSON.stringify(arr));
      copy_arr.forEach((e) => {
        delete e.loading;
        delete e[this.getSqlKey('owner')];
        delete e[this.getSqlKey('created')];
        delete e[this.getSqlKey('updated')];
        delete e[this.getSqlKey('id')];
      });

      let colNames = Object.keys(copy_arr[0]);
      let colVals = copy_arr;

      // Translate keys to labels
      colNames.forEach((part, index) => {
        if (colNames[index] != this.getSqlKey('id'))
          colNames[index] = this.itemsAsObjects[colNames[index]];
      });

      // Create CSV-String from values
      let vals = colVals
        .map((row) => {
          return Object.values(row)
            .map((value) => {
              return typeof value === 'string' ? value : JSON.stringify(value);
            })
            .join(';');
        })
        .join('\n');

      // Create CSV-String from col names
      let cols = colNames.join(';') + '\n';

      return cols + vals;
    },
    download(content) {
      let dataStr =
        'data:text/csv;charset=utf-8,' + encodeURIComponent(content);
      var link = document.createElement('a');
      link.setAttribute('href', dataStr);
      link.setAttribute(
        'download',
        this.nameWithoutPrefix(this.tableName) + '.csv'
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    nameWithoutPrefix(name) {
      return name.split('_').slice(1).join('_');
    },
    async exportItem() {
      this.checkRefreshToken();
      const content = await this.objectsToCSV([this.selectedItem]);
      this.download(content);
    },
    async runAction(id) {
      try {
        const params = `?id=${id}&databaseid=${this.database.name}&model=${this.selectedItem.id}`;
        const response = await runFlowById(params);

        if (response && response.status === 200 && response.data) {
          this.$set(this.htmlViewerModal, 'myHtml', response.data);
          this.$set(this.htmlViewerModal, 'isHtmlViewerVisible', true);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log({ error });
      }
    },
    closeHtmlViewer() {
      this.$set(this.htmlViewerModal, 'isHtmlViewerVisible', false);
    },
    async createNewAction() {
      let id = this.newID();
      let rslt = await this.$store.dispatch('createNewFlow', {
        id: id,
        type: 'action',
        dataType: 'custom',
        fileKey: this.selectedItem.id,
        tableID: this.database.name,
      });

      if (rslt == 'Access Token has expired') {
        this.handleTokenExpired();
      } else {
        this.$router.push({
          path: '/',
          query: {
            section: 'process-designer',
            process: id,
          },
        });
      }
    },
    scrollbarVisible() {
      const element = document.querySelectorAll('.inner-scroll')[0];
      if (element) {
        this.isScrollVisible = element.scrollHeight > element.clientHeight;
      }
    },
  },
  created() {
    this.item = JSON.parse(JSON.stringify(this.selectedItem));
  },
  mounted() {
    document.body.addEventListener('click', this.hideUpdateModal);
    this.scrollbarVisible();
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.hideUpdateModal);
  },
  computed: {
    showFormbuilderOnItemEditMode() {
      return (
        !this.isAddingNewItem &&
        !this.loading &&
        this.selectedItem &&
        Object.keys(this.selectedItem).length
      );
    },
    user() {
      return this.$store.state.user;
    },

    emptySchema() {
      let schema = JSON.parse(this.database.schema);
      schema.forEach((e) => {
        if (e.type != 'link') {
          if (e.type == 'html') return;
          if (['checkbox', 'objectlist'].includes(e.type)) e.value = [];
          else if (e.type === 'linktodb') return e;
          else if (!e.default) e.value = null;
        } else {
          e.value.database = null;
          e.value.item = null;
        }
      });
      // schema = schema.reduce((acc, cur) => {
      //   if (
      //     this.database.sql_cdls
      //       ? !Object.values(JSON.parse(this.database.sql_cdls)).find(
      //           (key) => key === cur.name
      //         )
      //       : true
      //   ) {
      //     if (cur.type != 'link') {
      //       if (cur.type == 'html') return;
      //       if (['checkbox', 'objectlist'].includes(cur.type)) cur.value = [];
      //       else if (!cur.default) cur.value = null;
      //     } else {
      //       cur.value.database = null;
      //       cur.value.item = null;
      //     }
      //     acc.push(cur);
      //   }
      //   return acc;
      // }, []);
      schema.push({
        name: 'id',
        label: 'id',
        type: 'number',
        value: this.selectedId,
        attributes: {},
        options: [],
      });
      return schema;
    },
    schemaWithSelectedElValues() {
      if (this.selectedItem) {
        let schema = JSON.parse(JSON.stringify(this.emptySchema));
        let selectedEl = this.selectedItem;

        schema.forEach((e) => {
          if (selectedEl.hasOwnProperty(e.name)) {
            if (e.type == 'radio') {
              e.options.map((el) => {
                el.label == selectedEl[e.name]
                  ? (el.checked = true)
                  : (el.checked = false);
              });
            } else if (e.type == 'checkbox') {
              e.options.forEach((el) => {
                // Make sure element exists and is array
                if (selectedEl[e.name] instanceof Array) {
                  selectedEl[e.name].includes(el.label)
                    ? (el.checked = true)
                    : (el.checked = false);
                }
              });
            }

            e.value = selectedEl[e.name];
          }
        });
        return schema;
      } else return null;
    },
    formElements() {
      return this.$refs.formBuilder.elements;
    },
    tableName() {
      return this.database.name;
    },
    selectedId() {
      if (this.selectedItem) return this.selectedItem.id;
      else return this.newID();
    },
    itemsAsObjects() {
      let translations = {};
      this.dataSchema.forEach((e) => (translations[e.name] = e.label));
      return translations;
    },
    actionList() {
      return this.$store.state.flows.filter(
        (e) => e.type == 'action' && e.table_id == this.database.name
      );
    },
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vnode) {
        el.eventSetDrag = function () {
          el.setAttribute('data-dragging', 'yes');
        };
        el.eventClearDrag = function () {
          el.removeAttribute('data-dragging');
        };
        el.eventOnClick = function (event) {
          var dragging = el.getAttribute('data-dragging');

          // Check that the click was outside the el and its children, and wasn't a drag
          if (!(el == event.target || el.contains(event.target)) && !dragging) {
            // call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener('touchstart', el.eventClearDrag);
        document.addEventListener('touchmove', el.eventSetDrag);
        document.addEventListener('click', el.eventOnClick);
        document.addEventListener('touchend', el.eventOnClick);
      },
      unbind: function (el) {
        document.removeEventListener('touchstart', el.eventClearDrag);
        document.removeEventListener('touchmove', el.eventSetDrag);
        document.removeEventListener('click', el.eventOnClick);
        document.removeEventListener('touchend', el.eventOnClick);
        el.removeAttribute('data-dragging');
      },
    },
  },
  components: {
    FormBuilder,
    Updates,
    GeneralDropdown,
    htmlViewer,
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  padding: 25px 40px 40px 43px;
  width: 100%;
  height: 100%;
  overflow: auto;
  display: unset;
  background: #ffffff;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.modal > h1 {
  padding-top: 60px;
  color: #313745;
  font-family: 'Inv Eina 03', 'Eina 03', -apple-system, BlinkMacSystemFont,
    'Open Sans', open-sans, sans-serif;
  font-size: 30px;
  font-weight: 600;
  letter-spacing: -0.12px;
  line-height: 41px;
  text-align: center;
  display: block;
  width: 860px;
  margin: 0 auto 40px;
  border: 0;
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  position: relative;
  z-index: 1;
  -webkit-font-smoothing: antialiased;
  text-transform: none;
  font-size: 38px;
  padding-bottom: 6px;
}

.modal > h2 {
  color: #313745;
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.16px;
  line-height: 19px;
  padding-bottom: 55px;
}
/* Style that has no refference*/
.group-wrapper {
  overflow: auto;
}

.modal > form {
  margin: 0 20%;
}

.modal > form > h3 {
  color: #22252b;
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.25px;
  line-height: 16px;
  text-align: left;
  margin-top: 35px;
}

.modal > h4 {
  color: rgba(85, 93, 109, 0.4);
  font-family: 'Open Sans', open-sans, sans-serif;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  padding-bottom: 55px;
}

input {
  float: none;
  text-align: center;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding: 15px 20px 15px 20px;
  width: 290px;
  padding-bottom: 15px;
  margin-bottom: 0;
  height: 51px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 22px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 52px;
  width: 100%;
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid #7e8890;
  color: #22252b;
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 0.23px;
  line-height: 16px;
  padding: 15px 20px 15px 20px;
  text-align: left;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 400px;
  width: 500px;
  overflow: hidden;
}

::placeholder {
  color: #e3e3e3;
  opacity: 1;
}

.pull-right {
  float: right;
  position: relative;
  z-index: 2;
  padding: 5px 45px 5px 5px;
  left: 2%;
  bottom: 2%;
  display: flex;
  align-items: center;
}

.pull-right div {
  padding-right: 20px;
}
/* Style that has no refference*/
.pull-left {
  float: left;
  z-index: 2;
  height: 30px;
  position: fixed;
}

/* Style that has no refference*/
.item {
  height: 175px;
}

.group-wrapper .item {
  height: 175px;
}

.group-wrapper {
  max-width: 960px;
  margin: 0 auto 0px;
  text-align: center;
  margin-top: 5px;
  overflow: auto;
  width: 100%;
  padding-left: 30px;
  padding-right: 30px;
}

.group-wrapper .item-wrapper:hover .img-wrapper {
  filter: none;
}

.group-wrapper .item-wrapper.active .img-wrapper {
  filter: none;
}

.group-wrapper .item-wrapper.active {
  box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.1);
  z-index: 2;
}

.group-wrapper .item-wrapper:hover {
  box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.1);
  z-index: 2;
}

.group-wrapper .item-wrapper .img-wrapper {
  filter: grayscale(82%) hue-rotate(246deg) opacity(30%);
}

.group-wrapper .item-wrapper {
  display: inline-block;
  width: 212px;
  height: 230px;
  margin: 10px;
  opacity: 1;
  cursor: pointer;
  text-align: -webkit-match-parent;
  box-shadow: none;
  overflow: hidden;
}

.group-wrapper .img-wrapper {
  width: 100%;
  height: 130px;
}

.group-wrapper input {
  display: initial;
}

.group-wrapper .logo {
  position: absolute;
  width: 43%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  float: none;
  background-color: #fff;
  padding: 0 6px 0 6px;
}

.group-wrapper .item-wrapper h2 {
  color: #434c5e;
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0.16px;
  line-height: 19px;
}

.footer {
  position: relative;
  display: block;
  width: 100%;
  text-align: center;
  height: 100px;
}

.footer .btn-black {
  cursor: pointer;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.951);
  border: 3px solid rgba(0, 0, 0, 0.916);
  background-color: rgba(0, 0, 0, 0.916);
  border-radius: 0.375em;
  font-family: proxima-nova, Helvetica Neue, Arial, sans-serif;
  font-weight: 400;
  line-height: 23px;
  padding: 0.6rem 1.6rem;
  font-size: 0.9375rem;
  margin-bottom: 25px;
  margin-top: 25px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
}

.footer .btn-black:hover {
  color: #fff;
  border: 3px solid #353434;
  background-color: #353434;
}

.footer .btn-black.disabled {
  background: #3a3b3b88;
  cursor: not-allowed;
}
/* Style that has no refference*/
.group-wrapper .item-wrapper .description {
  font-family: 'SF UI Text', -apple-system, system-ui, BlinkMacSystemFont,
    'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 12px;
  line-height: 19px;
  text-align: center;
  text-transform: none;
  color: #7b8496;
  -webkit-font-smoothing: antialiased;
  max-width: 100%;
  margin: 0px 13px 0px 13px;
  opacity: 0;
  transform: translateY(15px);
  transition: 0.2s ease;
}

.group-wrapper .item-wrapper:hover .description {
  opacity: 1;
  transform: translateY(0);
  -webkit-transform: translateY(0);
}

.group-wrapper .item-wrapper.active .description {
  opacity: 1;
  transform: translateY(0);
  -webkit-transform: translateY(0);
}

.toggle-list-wrapper {
  width: 100%;
  left: 0px;
  max-width: unset;
  padding-top: 10px;
  top: -35px;
}

.toggle-list-wrapper .item {
  height: 30px;
}

.toggle-list-wrapper .item .label {
  text-transform: uppercase;
  font-weight: 500;
  margin-bottom: 8px;
  margin-top: 8px;
  font-size: 14px;
}

input {
  cursor: text;
}

.create-update-db-item .loading {
  width: 96%;
  height: 90%;
  background-color: #ffff;
  position: absolute;
  top: 50px;
}

.progress-icon-wrapper {
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  height: fit-content;
}

.progress-icon-wrapper .progress-icon {
  position: relative;
  width: 70px;
  height: 70px;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}

.progress-icon-wrapper p {
  margin-bottom: 50px;
  text-align: center;
}

.progress-icon:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #313745;
  border-color: #313745 transparent #313745 transparent;
  animation: progress-icon 1.2s linear infinite;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

[disabled] {
  opacity: 0.5;
  cursor: not-allowed !important;
}

.create-update-db-item .search {
  width: fit-content;
  padding: 0;
  height: 31px;
  margin-right: auto;
  margin-bottom: 10px;
  height: 44px;
  cursor: auto;
  box-sizing: border-box;
}

.create-update-db-item .search.active {
  border-bottom: solid 2px rgb(255, 51, 102);
}

.create-update-db-item .search-icon {
  background-image: url(data:image/png;base64,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);
  background-size: 20px;
  overflow: hidden;
  display: block;
  width: 28px;
  height: 21px;
  float: left;
  background-position: 0px 0px;
  background-repeat: no-repeat;
  margin-top: 13px;
  cursor: pointer;
}

.create-update-db-item .search input {
  border: 0;
  outline: none;
  width: 0;
  margin-left: 5px;
  cursor: initial;
  font-size: 13px;
  -webkit-font-smoothing: antialiased;
  font-weight: 300;
  height: 100%;
  background: transparent;
  padding: 0;
  transition: width 0.3s ease, border-color 0.3s ease;
  margin-bottom: 0px;
}

.create-update-db-item .search.active input {
  width: 230px;
}
.create-update-db-item ::v-deep .inner-scroll {
  height: calc(100% - (116px + 44px + 65px));
  overflow-y: auto;
}
.create-update-db-item ::v-deep .inner-scroll.has-footer {
  height: calc(100% - (107px + 44px + 65px + 100px));
  overflow-y: auto;
}

.modal .btn-logs {
  opacity: 0.7;
  background-image: url(../assets/img/project-sprite.png);
  background-size: 882px 840px;
  background-position: -800px -470px;
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  -webkit-transition: opacity 0.2s ease-in-out;
  transition: opacity 0.2s ease-in-out;
  cursor: pointer;
  filter: brightness(0.5);
}
.modal .btn-download {
  opacity: 0.7;
  background-image: url(../assets/img/project-sprite.png);
  background-size: 882px 840px;
  background-position: -867px -519px;
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  -webkit-transition: opacity 0.2s ease-in-out;
  transition: opacity 0.2s ease-in-out;
  cursor: pointer;
  filter: brightness(0.5);
}

.modal .btn-more {
  opacity: 0.7;
  background-image: url(../assets/img/project-sprite.png);
  background-size: 882px 840px;
  background-position: -463px -750px;
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  -webkit-transition: opacity 0.2s ease-in-out;
  transition: opacity 0.2s ease-in-out;
  filter: brightness(0.5);
}
.custom-db-log-modal .modal {
  position: fixed;
  width: 438px;
  margin: unset;
  left: unset;
  padding: 0;
}

.more-icon img {
  width: 20px;
}
.create-update-db-item .serach-main-wrap.custom-item-edit {
  padding: 0 16px;
  max-width: 80%;
  margin: 0 auto;
}

.create-update-db-item .serach-main-wrap.custom-item-edit .search-wrap {
  max-width: 85%;
  margin: 0 auto;
  padding: 12px;
}
</style>
